import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { changeSelectedPharmacy } from 'app/shared-components/store/pharmacySelectorSlice';

import useSelectedPharmacyId from './useSelectedPharmacyId';

export default function useSelectPharmacyById(pharmacyId) {
  const dispatch = useDispatch();
  const selectedPharmacyId = useSelectedPharmacyId();

  useEffect(() => {
    if (!selectedPharmacyId && pharmacyId) {
      dispatch(changeSelectedPharmacy(pharmacyId));
    }
  }, [dispatch, pharmacyId, selectedPharmacyId]);
}
